import {CSSProperties, FC} from 'react';


export interface IIconNewProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconNew: FC<IIconNewProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="m20.172 12 .79 2.056a.563.563 0 0 1-.171.64l-1.712 1.388-.347 2.178a.562.562 0 0 1-.467.467l-2.18.347-1.386 1.713a.56.56 0 0 1-.64.172L12 20.17l-2.06.791a.56.56 0 0 1-.638-.17l-1.387-1.714-2.18-.347a.562.562 0 0 1-.467-.466l-.347-2.18-1.712-1.387a.563.563 0 0 1-.17-.64L3.827 12l-.79-2.06a.561.561 0 0 1 .172-.637l1.712-1.388.347-2.18a.562.562 0 0 1 .468-.466l2.178-.347L9.303 3.21a.562.562 0 0 1 .637-.172l2.06.79 2.06-.79a.563.563 0 0 1 .637.171l1.387 1.713 2.18.347c.24.038.429.226.467.467l.347 2.179 1.712 1.388c.19.153.259.41.172.637l-.79 2.06Zm-.406 2.079-.72-1.879a.562.562 0 0 1 0-.403l.721-1.879-1.563-1.267A.562.562 0 0 1 18 8.303l-.315-1.988L15.697 6a.56.56 0 0 1-.35-.201l-1.266-1.564-1.878.721a.561.561 0 0 1-.402 0l-1.88-.72-1.266 1.563a.566.566 0 0 1-.35.201l-1.989.316-.315 1.988a.562.562 0 0 1-.202.348L4.235 9.918l.721 1.88c.05.13.05.274 0 .404l-.72 1.878 1.56 1.267c.11.087.18.211.203.348l.315 1.988L8.303 18a.56.56 0 0 1 .35.202l1.266 1.563 1.88-.721a.566.566 0 0 1 .401-.001l1.88.72 1.267-1.563a.566.566 0 0 1 .35-.201l1.988-.316.315-1.988a.562.562 0 0 1 .203-.348l1.563-1.267Zm-11.14-4.33a.563.563 0 0 1 1.124 0v4.5a.562.562 0 0 1-1.065.25L7.5 12.133v2.117a.563.563 0 0 1-1.124 0v-4.5a.562.562 0 0 1 1.065-.252l1.184 2.37V9.748Zm3.936 2.813a.563.563 0 0 0 0-1.125H12v-1.125h.562a.563.563 0 0 0 0-1.125h-1.124a.563.563 0 0 0-.563.562v4.5c0 .31.252.562.563.562h1.124a.563.563 0 0 0 0-1.125H12v-1.124h.562ZM16.5 9.748a.563.563 0 0 1 1.125 0v4.5a.56.56 0 0 1-.562.561.562.562 0 0 1-.503-.31l-.622-1.243-.621 1.244a.564.564 0 0 1-1.066-.252v-4.5a.563.563 0 0 1 1.124 0v2.117l.059-.118c.191-.381.816-.381 1.007 0l.06.118V9.75Z" clipRule="evenodd" />
        </svg>
    );
};
